<template>
    <div class="auth__signin__form" :style="{ 'color': ThemeStore.loginPage.rightTextColor || '#253072' }">
        <div>
            <div v-if="ThemeStore.loginPage.logo && ThemeStore.loginPage.logo.url" class="logo-container">
                <img :src="ThemeStore.loginPage.logo.url" :alt="ThemeStore.loginPage.logo.name || 'Logo'"/>
            </div>
            <h2 v-if="!ThemeStore.loginPage.hideWelcome">Bienvenue !</h2>
            <h3 v-if="ThemeStore.loginPage.rightUpperText && ThemeStore.loginPage.rightUpperText.trim() !== ''"
                :style="{ 'text-align': 'center', 'font-weight': 'bold', 'margin-top': '1em' }"
                v-html="ThemeStore.loginPage.rightUpperText.replace(/\n/g, '<br />')"/>
            <h3 v-if="ThemeStore.loginPage.rightLowerText && ThemeStore.loginPage.rightLowerText.trim() !== ''"
                v-html="ThemeStore.loginPage.rightLowerText.replace(/\n/g, '<br />')"/>
            <h3 v-else>
              Connectez-vous à votre compte
            </h3>
        </div>

        <form @submit.prevent="submit">
            <div class="field-holder">
                <input type="text" required v-model="username" id="username"
                :class="{
                    'error': signinError
                }" :disabled="processing" :style="{ 'color': '#253072' }"/>
                <label for="username" class="input__label">Votre identifiant</label>
            </div>
            <div class="field-holder">
                <input :type="passwordType" required v-model="password" id="password"
                :class="{
                    'error': signinError
                }" :disabled="processing" :style="{ 'color': '#253072' }"/>
                <label for="password" class="input__label">Votre mot de passe</label>
                <TogglePasswordDisplay @togglePassword="togglePassword"/>
            </div>
            <div class="field-holder inline">
                <label class="switch">
                    <input type="checkbox" v-model="remember" value="1">
                    <span class="slider"></span>
                    <span class="label" :style="{ 'color': ThemeStore.loginPage.rightTextColor || '#6A707C' }">Se souvenir de moi</span>
                </label>
                <router-link :to="{ name: 'auth.lost-id' }" :style="{ 'color': ThemeStore.loginPage.rightTextColor || '#253072' }">Mot de passe oublié ?</router-link>
            </div>
            <button type="submit" :disabled="processing"
            class="auth__signin__form__submit"
            :style="{
              'background-color': ThemeStore.loginPage.buttonColor,
              'color': ThemeStore.loginPage.buttonTextColor || '#FFFFFF'
            }">Je me connecte</button>
        </form>
    </div>
</template>
<script>
import { useThemeStore } from "@/store/ThemeStore";
import TogglePasswordDisplay from '@/components/Auth/Signin/TogglePasswordDisplay.vue'
export default {
    props: {
        signinError: Boolean,
        processing: Boolean
    },
    data() {
        const ThemeStore = useThemeStore();   
        return {
            ThemeStore: ThemeStore,
            remember: false,
            username: null,
            password: null,
            passwordType: 'password'        }
    },
    components: {
        TogglePasswordDisplay
    },
    mounted () {
        if (this.$route.query.username) {
            this.username = this.$route.query.username;
        }
    },
    methods: {
        submit () {
            this.$emit('processed', {
                username: this.username,
                password: this.password,
                remember: this.remember
            })
        },
        togglePassword () {
            this.passwordType = this.passwordType == 'password' ? 'text' : 'password'
        }
    }
}
</script>
